import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Toaster } from "react-hot-toast";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from "react-router-dom";
import MainLayout from "./layout/mainLayout/MainLayout";
import "./styles/globals.css";
import "./styles/spacing.css";
import "./styles/typo.css";
import Activite from "./views/activite/Activite";
import Catalogue from "./views/catalogue/Catalogue";
import Enregistre from "./views/enregistres/Enregistre";
import Immobilier from "./views/immobilier/Immobilier";
import Login from "./views/login/Login";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import Crawler from "./views/crawler/Crawler";
import BackOffice from "./views/backOffice/BackOffice";
import PublicRoute from "./utils/PublicRoute";
import PwdReset from "./views/pwdReset/PwdReset";

const App = () => {
  return (
    <Router>
      <MainLayout>
        <Toaster
          toastOptions={{
            duration: 5000,
          }}
        />
        <Routes>
          {/* Root redirect */}
          <Route path="/" element={<Navigate to="/immobilier" replace />} />

          {/* Public Route */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/pwd-reset"
            element={
              <PublicRoute>
                <PwdReset />
              </PublicRoute>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/immobilier"
            element={
              <ProtectedRoutes
                allowedRoles={["Collaborateur", "Administrateur"]}
              >
                <Immobilier />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/activite"
            element={
              <ProtectedRoutes
                allowedRoles={["Collaborateur", "Administrateur"]}
              >
                <Activite />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/catalogue"
            element={
              <ProtectedRoutes
                allowedRoles={["Collaborateur", "Administrateur"]}
              >
                <Catalogue />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/enregistres"
            element={
              <ProtectedRoutes
                allowedRoles={["Collaborateur", "Administrateur"]}
              >
                <Enregistre />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/crawlers"
            element={
              <ProtectedRoutes allowedRoles={["Administrateur"]}>
                <Crawler />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/backoffice"
            element={
              <ProtectedRoutes allowedRoles={["Administrateur"]}>
                <BackOffice />
              </ProtectedRoutes>
            }
          />
        </Routes>
      </MainLayout>
    </Router>
  );
};

export default App;
